/* eslint-disable */
// import requestRawDev from '@/utils/requestRawDev'
import requestDev from '@/utils/requestDev'
import { APIReportPHP } from '@/utils/servicesApi'
const qs = require('qs')

export function listSmartReplyDetailMonthly(params) {
    return requestDev({
        url: APIReportPHP() + '/message/smartreply-monthly-detail',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listSmartReplysMonthly(params) {
    return requestDev({
        url: APIReportPHP() + '/message/smartreply-monthly',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listButtonsDetailMonthly(params) {
    return requestDev({
        url: APIReportPHP() + '/message/buttons-monthly-detail',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listButtonsMonthly(params) {
    return requestDev({
        url: APIReportPHP() + '/message/buttons-monthly',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listBroadcast(params) {
    return requestDev({
        url: APIReportPHP() + '/message/broadcast',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listMessage(params) {
    return requestDev({
        url: APIReportPHP() + '/message/list',
        method: 'POST',
        data: qs.stringify(params)
    })
}


// WEBPACK FOOTER //
// ./src/api/messageReport.js